import { render, staticRenderFns } from "./BasicMailerForm.vue?vue&type=template&id=e8acc634&scoped=true&"
import script from "./BasicMailerForm.vue?vue&type=script&lang=js&"
export * from "./BasicMailerForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicMailerForm.vue?vue&type=style&index=0&id=e8acc634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8acc634",
  null
  
)

export default component.exports